import api from './axiosInstance';
import { API_BASE_URL } from '../config';

const AUDIT_LOG_URL = `${API_BASE_URL}/AuditLog`;

export const getPagedAuditLogs = async (
  page = 1,
  pageSize = 10,
  search = '',
  sortBy = null,
  desc = null
) => {
  try {
    const params = { page, pageSize };
    if (search) params.search = search;
    if (sortBy) params.sortBy = sortBy;
    if (desc !== null && desc !== undefined) params.desc = desc;
    const response = await api.get(AUDIT_LOG_URL, { params });
    return {
      total: response.data.total || 0,
      data: response.data.data || [],
    };
  } catch (error) {
    console.error('Error fetching audit logs:', error);
    throw error;
  }
};

export const filterAuditLogsByDateRange = async (
  startDate,
  endDate,
  page = 1,
  pageSize = 10,
  search = '',
  sortBy = null,
  desc = null
) => {
  try {
    const params = {
      startDate,
      endDate,
      page,
      pageSize,
    };
    if (search) params.search = search;
    if (sortBy) params.sortBy = sortBy;
    if (desc !== null && desc !== undefined) params.desc = desc;
    const response = await api.get(`${AUDIT_LOG_URL}/filter`, { params });
    return {
      total: response.data.total || 0,
      data: response.data.data || [],
    };
  } catch (error) {
    console.error('Error filtering audit logs:', error);
    throw error;
  }
};
